SP.lang.Class.define("SP.sitekit.form.validator.FileExtension", {

	_options: null,

	init: function (options) {
		this._options = options;
	},

	isValid: function (value, el) {

		var me = this;

		var file = el.files.length >= 1 ? el.files[0] : null;
		if (file !== null) {

			var valid;

			if (me._options.includes) {
				valid = false;
				SP.lang.Array.each(me._options.includes, function(i, extension) {
					if (SP.lang.String.endsWith(file.name, "." + extension)) {
						valid = true;
						return false;
					}
				});
				if (!valid) {
					return false;
				}
			}

			if (me._options.excludes) {
				valid = true;
				SP.lang.Array.each(me._options.includes, function(i, extension) {
					if (SP.lang.String.endsWith(file.name, "." + extension)) {
						valid = false;
						return false;
					}
				});
				if (!valid) {
					return false;
				}
			}
		}
		return true;
	},

	getMessage: function () {
		return this._options.messages.fileExtension;
	}

});
